<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="expenseTypeAudits && expenseTypeAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="expenseTypeAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Expense Type audits </ng-template>
</ng-template>
